export default [
    {
        path: '/dashboard/credential',
        meta: {
            menuLabel: 'Credential Courses',
        },
        components: {
            default: () => import('../../views/memberDashboard/dashboard/index.vue'),
            header: () => import('../../views/memberDashboard/header/index.vue'),
            footer: () => import('../../views/public/footer/index.vue'),
        },
        children: [
            {
                path: 'catalogue',
                name: 'memberDashboard.credential.catalogue',
                meta: {
                    menuLabel: 'View Courses',
                    middleware: {
                        mustBeAuthenticated: true
                    }
                },
                component: () => import('@/modules/member/components/credential-courses'),
            },
            {
                path: 'results',
                name: 'memberDashboard.credential.results',
                meta: {
                    menuLabel: 'Certificates & History',
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },
                component: () => import('@/modules/member/components/credential-results'),
            },
            {
                path: 'badges',
                name: 'memberDashboard.credential.badges',
                meta: {
                    menuLabel: 'Digital Badges',
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },

                component: () => import('@/modules/member/components/credential-badges'),
            }
        ]
    },
    {
        path: '/dashboard/credential/catalogue/:slug',
        name: 'memberDashboard.credential.course',
        components: {
            default: () => import('@/modules/member/components/credential-learning'),
            header: () => import('@/views/memberDashboard/header/index.vue'),
            footer: () => import('@/views/public/footer/index.vue'),
        },
        props: {
            default: true,
        },
        children: [
            {
                path: 'modules/:moduleOrder',
                name: 'memberDashboard.credential.course.module',
                props: true,
                meta: {
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },

                component: () => import('@/modules/member/components/credential-learning-module'),
            },
            {
                path: 'modules/:moduleOrder/units/:unitOrder',
                name: 'memberDashboard.credential.course.module.unit',
                props: true,
                meta: {
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },

                component: () => import('@/modules/member/components/credential-learning-unit'),
            },
            {
                path: 'modules/:moduleOrder/units/:unitOrder/assessment',
                name: 'memberDashboard.credential.course.module.unit.assessment',
                props: true,
                meta: {
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },

                component: () => import('@/modules/member/components/credential-learning-unit-assessment'),
            },
            {
                path: 'modules/:moduleOrder/units/:unitOrder/result',
                name: 'memberDashboard.credential.course.module.unit.result',
                props: true,
                meta: {
                    middleware: {
                        mustBeAuthenticated: true,
                        mustHasRoles: ['credential_member']
                    }
                },

                component: () => import('@/modules/member/components/credential-learning-unit-result'),
            }
        ]
    }
]
